import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { endPoints } from "../../config/end-points";
import useHttp from "../../hooks/use-http";

import { campaignAction } from "../../store/campaign-store";

import TemplateList from "../Templates/TemplateList";
import { cuteToast } from "../UI/cute";
import Input from "../UI/Input";
const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop);
const Create = () => {
  const campaignRef = useRef();
  const [campaign, setCampaign] = useState({
    campaign_name: "",
    template_id: "",
    is_available: undefined,
  });

  const [showFav, setShowFav] = useState(0);

  const [isValid, setIsValid] = useState(undefined);
  const token = useSelector((state) => state.auth.token);

  const { sendRequest: checkCampaign } = useHttp();
  const { error, setError, sendRequest: insertCampaign } = useHttp();
  const dispatch = useDispatch();
  const history = useHistory();

  const scrollRef = useRef(null);

  useEffect(() => {
    document.title = `Create Campaign`;
  });
  // const responseData = (response) => {
  //   // console.log(response);

  //   if (response.status === 0) {
  //     setCampaign({ ...campaign, is_available: true });
  //     if (campaign.template_id !== "" && campaign.template_id) {
  //       setIsValid(true);
  //     } else {
  //       setIsValid(false);
  //     }
  //   } else {
  //     setCampaign({ ...campaign, is_available: false });
  //   }
  // };
  const campaignHandler = (event) => {
    const { value } = event.target;
    if (value) {
      // setCampaign({ ...campaign, campaign_name: value });

      checkCampaign(
        {
          url: endPoints.checkCampaignExits,
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: {
            name: value,
          },
        },
        (response) => {
          // console.log(response);

          if (response.status === 0) {
            setCampaign({
              ...campaign,
              campaign_name: value,
              is_available: true,
            });
            if (campaign.template_id !== "" && campaign.template_id) {
              setIsValid(true);
            } else {
              setIsValid(false);
            }
          } else {
            setCampaign({
              ...campaign,
              campaign_name: value,
              is_available: false,
            });
          }
        }
      );
    } else {
      setIsValid(false);
    }

    // console.log(campaign);
  };

  useEffect(() => {
    if (campaign.campaign_name === "") {
      campaignRef.current.focus();
    }

    // console.log("Calling");
  });

  // const campaignHandlerBlur = () => {
  //   if (campaign.campaign_name) {
  //     checkCampaign(
  //       {
  //         url: endPoints.checkCampaignExits,
  //         method: "POST",
  //         headers: {
  //           "access-control-allow-origin": "*",
  //           "Content-Type": "application/json",
  //           Authorization: "Bearer " + token,
  //         },
  //         body: {
  //           name: campaign.campaign_name,
  //         },
  //       },
  //       responseData
  //     );
  //   }
  // };

  const templateHandler = (id) => {
    setCampaign({ ...campaign, template_id: id });
    if (campaign.campaign_name !== "") {
      setIsValid(true);

      scrollToRef(scrollRef);
    } else {
      setIsValid(false);
    }
  };

  const resposeCamp = (response) => {
    // console.log(response);

    dispatch(campaignAction.setEditorpageLoad({ editor_page_load: false }));

    if (response.id) {
      history.push("/campaign/" + response.id + "/edit");
    }
  };

  const handleSubmit = () => {
    // console.log(campaign)
    // return false;
    if (isValid && campaign.is_available) {
      insertCampaign(
        {
          url: endPoints.insertCampaign,
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: {
            ...campaign,
          },
        },
        resposeCamp
      );
    } else {
      cuteToast({
        type: "error",
        message: "Pease enter campaign name and select tempplate",
        timer: 5000,
        title: "Campaign Invalid",
      });
      campaignRef.current.focus();
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (error) {
      // console.log(error);

      cuteToast({
        type: "error",
        message: error,
        timer: 5000,
        title: "Campaign Invalid",
      });

      setCampaign({ ...campaign, is_available: false });
      campaignRef.current.focus();
      setError(null);
    } else {
      console.log("Hello error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  const handleFav = (event) => {
    setShowFav(parseInt(event.target.value));
  };

  return (
    <>
      <section className="mid_wrap">
        <div className="container">
          <div className="row align-items-center mb-4">
            <div className="col-12">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Create video</li>
                </ol>
              </nav>
            </div>
          </div>

          <div className="row mb-4 ">
            <div className="col-xl-5 col-lg-6 col-md-8">
              <label className="pull-right">
                <span className="pull-right">
                  {campaign.campaign_name.length}/20
                </span>
              </label>
              <Input
                ref={campaignRef}
                name="campaign_name"
                type="text"
                placeholder="Enter Campaign Name"
                maxLength={20}
                inputClass={`form-control txt1 ${
                  campaign.campaign_name.length >= 20 && "max-length"
                } ${
                  !campaign.is_available &&
                  campaign.is_available !== undefined &&
                  "invalid"
                }`}
                onChange={campaignHandler}

                // onBlur={campaignHandlerBlur}
              />
              {campaign.is_available && (
                <p className={`available text-success pull-right`}>
                  <b>Available</b>
                </p>
              )}

              {!campaign.is_available && campaign.is_available !== undefined && (
                <p
                  className={`red_lnk text-danger font-weight-bold pull-right`}
                >
                  <b>Not Available</b>
                </p>
              )}
            </div>
            <div className="col-xl-7 col-lg-6 col-md-4">
              {isValid && (
                <>
                  <button
                    style={{ marginTop: "6%" }}
                    className="btn min_w pull-right"
                    onClick={handleSubmit}
                  >
                    Save & Next
                  </button>
                </>
              )}
            </div>
          </div>

          <div className="row mb-4">
            <div className="col-8">
              <h2 className="m-0">Select A Template</h2>
            </div>

            <div className="col-4 d-flex">
              <select
                name=""
                className="form-control slectbx wdh_auto text-center ms-auto"
                onChange={handleFav}
                value={showFav}
              >
                <option value="0">All</option>
                <option value="1">My Favourite</option>
              </select>
            </div>
          </div>

          <div className="row">
            <TemplateList
              templateId={templateHandler}
              selectedTemp={campaign.template_id}
              showFav={showFav}
            />
          </div>

          <div className="rw text-end" ref={scrollRef}>
            {isValid && (
              <button className="btn min_w" onClick={handleSubmit}>
                Save & Next
              </button>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Create;
